module.exports = __webpack_public_path__ + "static/media/right-chevron.6f355b44.svg";